import { CSSProperties, FC } from "react";
import classes from "./style.module.scss";
import { IoMdRadioButtonOff } from "react-icons/io";
import { IoMdRadioButtonOn } from "react-icons/io";

const RadioButton: FC<{
  data: Array<{ [key: string]: string | number }>;
  value: string | number;
  pointer: { label: string; value: string };
  displayType?: "horizontal" | "vertical";
  labelPositon?: "right" | "left";
  onChange: (value: string | number) => void;
  styles?: CSSProperties;
  radioClasses?: string;
  disabled?: boolean;
}> = ({
  data = [],
  value = "",
  pointer = { label: "label", value: "value" },
  displayType = "horizontal",
  labelPositon = "right",
  onChange,
  styles = {},
  radioClasses,
  disabled = false,
}) => {
    return (
      <div
        className={`mt-1 ${classes.container}`}
        data-view={displayType}
        style={styles}
      >
        {data.map((item) => (
          <span
            key={`radio-${item[pointer.value]}`}
            className={`flex grow cursor-pointer items-center mb-2 ${classes.radio} ${radioClasses} ${disabled ? "cursor-not-allowed" : "cursor-pointer"
              }`}
            data-position={labelPositon}
            onClick={() => {
              if (!disabled) {
                onChange && onChange(item[pointer.value]);
              }
            }}
          >
            {value === item[pointer.value] ? (
              <IoMdRadioButtonOn className={`${classes.active}`} />
            ) : (
              <IoMdRadioButtonOff />
            )}
            <span className={`text-sm ml-1`}>{item[pointer.label]}</span>
          </span>
        ))}
      </div>
    );
  };
export default RadioButton;
